import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'clicklease-ui-elements';
import { environment } from '@envs/environment';
import {
    InitiateMobilePhoneResponse,
    VerifyMobilePhoneResponse,
} from './../../interfaces';

@Injectable({
    providedIn: 'root',
})
export class ContactUpdateService extends RequestService {
    protected readonly serviceBaseUrl: string = `${environment.API_URL}contact/`;

    public initiateMobilePhone(
        newPhone: string,
        expectedLastModifiedDate: string
    ): Observable<InitiateMobilePhoneResponse> {
        // Send the canonical 10-digit number (strip any input mask); the backend also normalizes.
        const digits = (newPhone ?? '').replace(/\D/g, '');
        return this.post<InitiateMobilePhoneResponse>({
            url: 'mobile-phone/initiate',
            params: { newPhone: digits, expectedLastModifiedDate },
            headers: {
                'Content-Type': 'application/json',
                'X-Request-Id': crypto.randomUUID(),
            },
        });
    }

    public verifyMobilePhone(
        verificationId: string,
        otpCode: string,
        newPhone: string,
        expectedLastModifiedDate: string,
        previousPhone: string
    ): Observable<VerifyMobilePhoneResponse> {
        // 10-digit canonical form (strip masks); the backend also normalizes.
        const newDigits = (newPhone ?? '').replace(/\D/g, '');
        const previousDigits = (previousPhone ?? '').replace(/\D/g, '');
        return this.post<VerifyMobilePhoneResponse>({
            url: 'mobile-phone/verify',
            // Backend DTO field is `code`, not `otpCode`. `contactId` is resolved server-side
            // from the rosekey claim, so the UI does not send it.
            params: {
                verificationId,
                code: otpCode,
                newPhone: newDigits,
                expectedLastModifiedDate,
                previousPhone: previousDigits,
            },
            headers: {
                'Content-Type': 'application/json',
                // account-service requires X-Request-Id on verify for idempotency.
                'X-Request-Id': crypto.randomUUID(),
            },
        });
    }

}
